import BodyFormItem from './components/BodyFormItem';

const AddItemPage = () => {
  return <BodyFormItem />;
};

export default AddItemPage;
